import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const ReproductionResultDropdown = ({ result, onChange }) => {
  const { t } = useTranslation();
  const [localValue, setLocalValue] = useState(result || '');

  // Sync if the parent data refreshes with a new value
  useEffect(() => { setLocalValue(result || ''); }, [result]);

  const handleChange = (e) => {
    setLocalValue(e.target.value);
    onChange(e);
  };

  return (
    <select name="cause" value={localValue} onChange={handleChange}>
      <option value="" disabled hidden>{t('repro_result_choose')}</option>
      <option value="pregnant"          >{t('pregnant')}</option>
      <option value="returned_to_estrus">{t('returned_to_estrus')}</option>
      <option value="aborted"           >{t('aborted')}</option>
      <option value="calved_alive"      >{t('calved_alive')}</option>
      <option value="calved_stillborn"  >{t('calved_stillborn')}</option>
      <option value="dam_died"          >{t('dam_died')}</option>
    </select>
  );
};

export default ReproductionResultDropdown;
